import React from 'react';
import { useTranslation } from 'react-i18next';
import { RTUData } from '../../types/RtuData';
import { humanizeStatusSource, humanizeStatusReason } from '../../utils/statusDisplayConfig';
import { OverviewRow, OverviewSectionCard } from './RTUDataDisplay';
import { formatDisplayDateTime } from '../../utils/dateTimeFormat';

interface RtuCanonicalFreshnessCardProps {
  data: RTUData | null | undefined;
}

const RtuCanonicalFreshnessCard: React.FC<RtuCanonicalFreshnessCardProps> = ({ data }) => {
  const { t } = useTranslation();

  const rows: OverviewRow[] = [
    { label: t('rtuDetail.status.canonicalLabel', { defaultValue: 'Canonical Status' }), value: data?.canonicalStatus || 'UNKNOWN' },
    { label: t('rtuDetail.status.observedLabel', { defaultValue: 'Status Observed Time' }), value: formatDisplayDateTime(data?.statusObservedAtUtc) },
    { label: t('rtuDetail.status.probeLabel', { defaultValue: 'Last Probe Time' }), value: formatDisplayDateTime(data?.lastProbeAtUtc) },
    { label: t('rtuDetail.infoRows.lastFileReceived', { defaultValue: 'Last File Received Time' }), value: formatDisplayDateTime(data?.lastFileReceivedAtUtc || data?.rtuHeader?.utcTime) },
    { label: t('rtuDetail.status.sourceLabel', { defaultValue: 'Check Method' }), value: humanizeStatusSource(data?.statusSource) },
    { label: t('rtuDetail.status.reasonLabel', { defaultValue: 'Probe Result' }), value: humanizeStatusReason(data?.statusReason) },
  ];

  return <OverviewSectionCard title={t('rtuDetail.sections.statusFreshness', { defaultValue: 'Status and Freshness' })} rows={rows} />;
};

export default RtuCanonicalFreshnessCard;
